import { createStyled } from '@mui/system';
import defaultTheme from './defaultTheme';
import styleFunctionSx from './styleFunctionSx';
const styled = createStyled({
  defaultTheme,
  styleFunctionSx
});
export default styled;